import React, { useEffect } from "react";
import "./About.css";
import teachers from "../../Assets/teachers_office.png";

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="mainContainer aboutPage">
      <div className="grid grid2Fr container">
        <div className="flex flexColumn content">
          <h3>About Us</h3>
          <h1>Our goal Is Your Child's Future!</h1>
          <p>
            We help you to build your child's future! The educational programs
            of our school will give your child all the necessary skills and
            knowledge to make everything they learned here work for them in the
            future.
          </p>
        </div>
        <div className="p2">
          <img src={teachers} alt="" />
        </div>
      </div>
      <div>
        <div className="mb1 mission">
          <h1>Our Mission</h1>
          <div>
            <p>
              Our primary aim at Madani School And College is to achieve
              excellence in education for our students within a cultivating,
              caring and secure Islamic environment.
            </p>

            <p className="mt1">
              The strong academic background we provide will help them graduate
              and take their place in society, as Muslim professionals who will
              not only serve as role models for generations of Muslims to come,
              but also as intelligent and thoughtful citizens who will serve as
              ambassadors between Islam and the West.
            </p>
          </div>
        </div>
        <div className="mission">
          <h1>Our Vision</h1>
          <div>
            <p>
              Madani School And College is dedicated in helping our students
              achieve excellence in education within a cultivating, caring and
              secure Islamic environment. We focus on providing our students
              with a holistic education and teach them how to manage their time,
              how to manage their education and how to present themselves and
              their work.
            </p>

            <p className="mt1">
              We teach them how to debate, how to reflect, how to critique and
              think. These are life-long skills that will help foster and
              develop the type of Muslim professionals/academics who can
              contribute positively to the world they inherit.
            </p>

            <p className="mt1">
              All of these methodologies, techniques and understandings employed
              by the school are strongly underpinned by a cultivating Islamic
              environment. At Madani School And College we expect the children
              to memorise as much of the Qur’an as they are able, we teach them
              Arabic, Islamic studies and all those matters which are necessary
              for them to complete their Islamic obligations. More importantly
              however, we teach them what the Qur’an means not only through
              their Islamic studies, but by creating an environment where they
              live their Islam by showing respect and kindness to one another,
              Muslims and non-Muslims alike.
            </p>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}
